import React from 'react'

import { Box } from '@material-ui/core'

import { BannerPartnerServices, Certification } from './components'

const GeneralInformations = () => {
  return (
    <Box>
      <BannerPartnerServices />
      <Certification />
    </Box>
  )
}

export default GeneralInformations
